import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const auditQuery = createApi({
  baseQuery,
  reducerPath: "auditQueries",
  endpoints: (builder) => ({
    getAudit: builder.mutation<any, any>({
      query: ({
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        data,
      }) => ({
        url: `${formatString(
          endPoints.audit.getAudit
        )}?from=${from}&size=${size}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    getModuleAudit: builder.mutation<any, any>({
      query: ({
        module,
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        data,
      }) => ({
        url: `${formatString(endPoints.audit.moduleAudit, {
          key: urlKeys.module,
          value: encodeURIComponent(module),
        })}?from=${from}&size=${size}${value && `&value=${value}`}${
          sort_by && `&sort_by=${sort_by}`
        }${sort_order && `&sort_order=${sort_order}`}`,
        method: "POST",
        body: data,
      }),
    }),
    getAuditDetails: builder.mutation<any, any>({
      query: ({
        audit_activity = "",
        activity_datetime = "",
        user_email = "",
        module = "",
      }) => ({
        url: `${formatString(
          endPoints.audit.getAuditDetails
        )}?audit_activity=${audit_activity}&activity_datetime=${activity_datetime}&user_email=${user_email}&module=${module}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAuditMutation,
  useGetModuleAuditMutation,
  useGetAuditDetailsMutation,
} = auditQuery;
